import { useCallback } from 'react';

import { payment } from '../common/validation';
import { TextField, TextFieldProps } from '../text-field';

export const CardCVVField = (props: TextFieldProps) => {
  const attachFormatter = useCallback((input?: HTMLInputElement) => {
    if (!input) {
      return;
    }
    payment.formatCardCVC(input);
  }, []);

  return (
    <TextField
      fullWidth
      type="password"
      autoComplete="on"
      inputProps={{
        inputMode: 'numeric',
        autoComplete: 'on',
        autocompletetype: 'cc-csc',
        pattern: '\\d*',
      }}
      label="CVV"
      inputRef={attachFormatter}
      {...props}
    />
  );
};
